import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckHistoryTriggerSources } from '@api/consistencyCheckParameters';

import { mapDropdownOptions } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_CHECK_HISTORY_TRIGGER_SOURCES } from '@constants/queryKeys';

interface IUseConsistencyCheckHistoryTriggerSources {
	consistencyCheckTriggerSources: TSelectOption<string>[];
	isLoadingConsistencyCheckTriggerSources: boolean;
}

const useConsistencyCheckHistoryTriggerSources = (): IUseConsistencyCheckHistoryTriggerSources => {
	const {
		data,
		isInitialLoading,
		isFetching,
	} = useQuery({
		queryKey: [CONSISTENCY_CHECK_HISTORY_TRIGGER_SOURCES],
		queryFn: getConsistencyCheckHistoryTriggerSources,
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'name',
			labelKey: 'title',
		}),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		consistencyCheckTriggerSources: data || [],
		isLoadingConsistencyCheckTriggerSources: isInitialLoading || isFetching,
	};
};

export default useConsistencyCheckHistoryTriggerSources;
